{
  "el": {
    "task_assignment": {
      "actions": {
        "add_assignee": "Προσθήκη υπευθύνου",
        "bulk_remove": "Αφαίρεση από την εργασία",
        "confirm": "Σήμανση ως ολοκληρωμένη",
        "create": "Εργασία",
        "delete": "Διαγραφή υπευθύνου",
        "document_add": "Προσθήκη αρχείου",
        "document_delete": "Διαγραφή",
        "due_in_month": "Σε έναν μήνα",
        "due_in_two_weeks": "Σε δύο εβδομάδες",
        "due_in_week": "Σε μία εβδομάδα",
        "due_remove": "Αφαίρεση προθεσμίας",
        "open": "Άνοιγμα",
        "reopen": "Άνοιγμα ξανά",
        "selectAll": "Επιλογή και των {total}",
        "send_and_notify": "Αποστολή και ειδοποίηση",
        "set_due_date": "Ορισμός προθεσμίας",
        "set_status": "Ορισμός κατάστασης",
        "unSelectAll": "Κατάργηση επιλογής",
        "upload_files": "Ανέβασμα {count} αρχείου | Ανέβασμα {count} αρχείων"
      },
      "assignee_scopes": {
        "external": "Εξωτερικό",
        "internal": "Εσωτερικό"
      },
      "assignee_types": {
        "customer": "Πελάτης",
        "employee": "Μέλος ομάδας",
        "partner": "Συνεργάτης"
      },
      "attributes": {
        "assignee": "Υπεύθυνος",
        "assignees": "Υπεύθυνοι",
        "comment": "Σχόλιο",
        "created_at": "Δημιουργήθηκε",
        "document": "Έγγραφο",
        "due_date": "Προθεσμία",
        "project": "Έργο",
        "status": "Κατάσταση",
        "task": "Εργασία",
        "unit": "Ακίνητο"
      },
      "confirm": {
        "assignees_count": "{count} υπεύθυνο | {count} υπευθύνους",
        "bulk_delete_accept": "Αφαίρεση",
        "bulk_delete_body": "Αυτό αφαιρεί την εργασία τους για αυτά τα ακίνητα. Η ίδια η εργασία και οι άλλοι υπεύθυνοι κρατούν τις δικές τους.",
        "bulk_delete_body_project": "Αυτό αφαιρεί την εργασία τους. Η ίδια η εργασία και οι άλλοι υπεύθυνοι κρατούν τις δικές τους.",
        "bulk_delete_header": "Αφαίρεση {count} υπευθύνου; | Αφαίρεση {count} υπευθύνων;",
        "complete_accept": "Ολοκλήρωση όλων",
        "complete_body": "Αυτό ορίζει την κατάσταση {status} για {assignees}, ακόμη και για εργασίες που ο πελάτης δεν έχει ολοκληρώσει ακόμη. Μετακινούνται στις ολοκληρωμένες εργασίες της λίστας τους.",
        "complete_header": "Ολοκλήρωση όλων;",
        "customer_tasks": "{count} εργασία πελάτη | {count} εργασίες πελατών",
        "customers_and_team": "{customers} και {team}",
        "delete_body": "Αυτό αφαιρεί την εργασία τους για αυτό το ακίνητο. Τα άλλα ακίνητα και οι άλλοι υπεύθυνοι κρατούν τις δικές τους.",
        "delete_body_project": "Αυτό αφαιρεί την εργασία τους. Οι άλλοι υπεύθυνοι κρατούν τις δικές τους.",
        "delete_header": "Αφαίρεση του {name} από {unit};",
        "delete_header_project": "Αφαίρεση του {name} από αυτή την εργασία;",
        "delete_sent_customers": "Αυτή είχε ήδη σταλεί, οπότε χάνεται και από την πύλη των πελατών.",
        "delete_sent_team": "Αυτή είχε ήδη σταλεί, οπότε χάνεται και από τη λίστα του {name}.",
        "document_delete_body": "Το αρχείο φεύγει και από τα έγγραφα της μονάδας.",
        "document_delete_body_project": "Το αρχείο φεύγει και από τα έγγραφα του έργου.",
        "document_delete_header": "Διαγραφή αυτού του αρχείου;",
        "draft_accept": "Επαναφορά όλων σε πρόχειρη",
        "draft_body": "Αυτό επαναφέρει {assignees} σε {status}. Η εργασία εξαφανίζεται από τη λίστα του πελάτη μέχρι να τη στείλεις ξανά. Τα email που έχουν ήδη σταλεί παραμένουν σταλμένα.",
        "draft_header": "Επαναφορά όλων σε πρόχειρη;",
        "send_body": "Αυτό ορίζει την κατάσταση {status} για {who}.",
        "send_customers": "Οι πελάτες βλέπουν αμέσως την εργασία στην πύλη τους και λαμβάνουν σχετικό email.",
        "send_header": "Αποστολή αυτής της εργασίας; | Αποστολή αυτών των εργασιών;",
        "send_permanent": "Μπορείς να τις επαναφέρεις σε Πρόχειρη αργότερα, αλλά η ειδοποίηση θα έχει ήδη σταλεί.",
        "send_team": "Τα μέλη της ομάδας βλέπουν την εργασία στον πίνακα ελέγχου τους και ειδοποιούνται.",
        "tasks_count": "{count} εργασία | {count} εργασίες",
        "team_tasks": "{count} εργασία ομάδας | {count} εργασίες ομάδας"
      },
      "deep_link": {
        "completed": "Αυτή η εργασία έχει ήδη ολοκληρωθεί.",
        "gone": "Αυτή η εργασία δεν είναι πλέον ανοιχτή."
      },
      "empty": {
        "filtered_description": "Προσάρμοσε τα φίλτρα σου ή καθάρισέ τα για να δεις όλες τις αναθέσεις.",
        "filtered_title": "Καμία ανάθεση δεν ταιριάζει με τα φίλτρα σου",
        "none_title": "Καμία ανάθεση"
      },
      "filters": {
        "assignee_any": "Όλοι οι υπεύθυνοι",
        "clear_all": "Εκκαθάριση όλων των φίλτρων",
        "done": "Τέλος",
        "due_window_values": {
          "none": "Χωρίς προθεσμία",
          "overdue": "Εκπρόθεσμη",
          "set": "Με προθεσμία"
        },
        "phase_any": "Όλες οι φάσεις",
        "show_only": "Εμφάνιση μόνο",
        "show_only_values": {
          "customers": "Πελάτες",
          "mine": "Ανατεθειμένες σε εμένα",
          "team": "Ομάδα"
        },
        "unit_any": "Όλα τα ακίνητα"
      },
      "labels": {
        "add_assignee": "Προσθήκη υπευθύνου",
        "add_customers": "Προσθήκη πελατών",
        "already_assigned": "Αυτή η εργασία έχει ήδη προστεθεί σε αυτό το ακίνητο.",
        "already_assigned_project": "Αυτή η εργασία έχει ήδη προστεθεί σε αυτό το έργο.",
        "assignees": "Ανατεθειμένοι",
        "assignees_subtitle": "Καθένας λαμβάνει τη δική του εργασία, ανά ακίνητο.",
        "assignees_title": "Ποιος πρέπει να το κάνει",
        "comment_earlier_round": "προηγούμενος γύρος",
        "comment_placeholder": "π.χ. ο μετρητής ήταν δύσκολα προσβάσιμος, αυτή είναι η καλύτερη φωτογραφία που μπόρεσα να τραβήξω",
        "comments_none": "Ο πελάτης δεν άφησε κανένα σχόλιο.",
        "comments_title": "Σχόλια για αυτήν την εργασία",
        "completed": "Ολοκληρωμένη",
        "confirm_message": "Θέλεις σίγουρα να σημειώσεις αυτή την εργασία ως ολοκληρωμένη;",
        "customers": "Πελάτες",
        "documents_none": "Δεν έχει ανέβει τίποτα ακόμη.",
        "documents_title": "Αρχεία αυτής της εργασίας",
        "earlier": "+{count} παλαιότερα",
        "my_tasks": "Οι εργασίες μου",
        "no_assignees": "Χωρίς υπευθύνους ακόμη.",
        "no_assignments": "Οι εργασίες που σου ανατίθενται εμφανίζονται εδώ.",
        "no_assignments_task": "Δεν υπάρχουν ακόμη αναθέσεις για αυτή την εργασία.",
        "previous_upload": "προηγούμενο ανέβασμα",
        "required": "Αυτό το πεδίο είναι υποχρεωτικό",
        "selectOne": "Επιλέξτε τουλάχιστον μία εργασία.",
        "select_task": "Επίλεξε μια εργασία",
        "selected": "{selected} επιλεγμένη | {selected} επιλεγμένες",
        "set_status_for": "Ορισμός κατάστασης για {name}",
        "status_hint_assignees": "τον υπεύθυνο | τους υπευθύνους",
        "status_hint_customer": "τον πελάτη",
        "status_hint_sent": "τους υπευθύνους στους οποίους στάλθηκε",
        "superseded": "αντικαταστάθηκε",
        "totalSelected": "Επιλέχθηκαν και οι {total}",
        "upload_hint": "Ανέβασε τα ζητούμενα έγγραφα για να ολοκληρώσεις αυτή την εργασία."
      },
      "status_hints": {
        "completed": "Η εργασία ολοκληρώθηκε. Παραμένει ορατή για {who}, στην ενότητα {completed}.",
        "draft": "Δεν είναι ακόμη ορατή για {who}. Όρισε την εργασία σε {open} για να την κοινοποιήσεις.",
        "requested": "Ορατή για {who}. Η εργασία πρέπει ακόμη να ολοκληρωθεί."
      },
      "statuses": {
        "completed": "Ολοκληρωμένη",
        "draft": "Πρόχειρη",
        "requested": "Ανοιχτή"
      },
      "toasts": {
        "bulk_delete": "Οι εργασίες αφαιρέθηκαν",
        "bulk_update": "Οι εργασίες ενημερώθηκαν",
        "completed": "Η εργασία ολοκληρώθηκε",
        "create": "Η εργασία δημιουργήθηκε",
        "delete": "Ο υπεύθυνος διαγράφηκε",
        "document_added": "Το αρχείο προστέθηκε",
        "document_deleted": "Το αρχείο διαγράφηκε",
        "reopened": "Η εργασία άνοιξε ξανά",
        "update": "Η εργασία ενημερώθηκε"
      }
    }
  }
}
